import React, { useEffect, useState } from "react"
import Editor from "../../../components/Editor"
import "ckeditor5/ckeditor5.css"
import { Button, Spinner } from "react-bootstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import axiosProvider from "../../../lib/AxiosProvider"
import { admin } from "../../../config/apiEndpoints"
import { toast } from "react-toastify"
import { useHandleUnauthorizedAccess } from "../../../lib/GlobalMethods"
import { HasModulePermission } from "../../../lib/GlobalMethods"
import { modulePermission } from "../../../lib/GlobalVariables"

const PrivacyPolicy = ({ currentTab, setCurrentTab }) => {
  const canEdit = HasModulePermission(modulePermission.setting, "edit")

  const [data, setData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)

  const validationSchema = Yup.object({
    paragraph: Yup.string().required(),
  })

  const { handleAccess } = useHandleUnauthorizedAccess()

  const fetchData = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.privacyPolicy,
      })

      handleAccess({ code: response?.data?.code })

      setData(response?.data?.data?.paragraph)
    } catch (error) {
      toast.error(error.message)
    }
  }
  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: "PATCH",
        endpoint: admin.privacyPolicy,
        data: values,
      })
      if (response?.data?.code === 200) {
        toast.success(response.data.message)
        setIsUpdate(false)
        setLoading(false)
      } else {
        setLoading(false)
        throw new Error(response?.response?.data?.message)
      }
    } catch (error) {
      toast.error(error.message)
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      paragraph: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { values, setFieldValue } = formik

  useEffect(() => {
    if (currentTab === "privacy") {
      fetchData()
    }
  }, [currentTab])
  return (
    <>
      <form onSubmit={formik?.handleSubmit}>
        {canEdit && !isUpdate && (
          <div className="d-flex justify-content-end mb-3">
            <Button variant="primary" onClick={() => setIsUpdate(true)}>
              Update
            </Button>
          </div>
        )}
        <Editor
          name="paragraph"
          value={values.paragraph}
          onChange={(event, editor) => {
            setFieldValue("paragraph", editor.getData())
          }}
          onBlur={(editor) => {
            setFieldValue("paragraph", formik?.values.paragraph.trim())
          }}
          data={data}
          isReadOnly={true}
          disabled={isUpdate ? false : true}
        />
        {isUpdate && (
          <div className="mt-3">
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? (
                <Spinner size="sm" animation="border" variant="white" />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        )}
      </form>
    </>
  )
}

export default PrivacyPolicy
